import { common } from '@mui/material/colors';
import { alpha } from '@mui/material/styles';

export const YellowWarning = '#a0932a';

export const Grey = {
  50: '#FAFAFA',
  100: '#F5F5F5',
  200: '#EEEEEE',
  300: '#E0E0E0',
  400: '#BDBDBD',
  500: '#9E9E9E',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#F5F5F5',
  A200: '#EEEEEE',
  A400: '#BDBDBD',
  A700: '#616161',
} as const satisfies Record<string, `#${string}`>;

export const Error = {
  contrastText: common.white,
  dark: '#8D0A00',
  light: '#FEE4E2',
  main: '#B42318',
};

export const Warning = {
  contrastText: common.white,
  dark: '#CE4900',
  light: '#FEF0C7',
  main: '#B54708',
};

export const Success = {
  contrastText: common.white,
  dark: '#004129',
  light: '#e5fdcf',
  main: '#06764D',
};

export const Info = {
  contrastText: common.white,
  dark: '#004268',
  light: '#def3ff',
  main: '#016caa',
};

export const Pending = {
  contrastText: common.white,
  dark: '#240679',
  light: '#e6d8fb',
  main: '#6343bf',
};

export const Secondary = {
  contrastText: common.white,
  dark: '#002855',
  light: '#f2f8fe',
  main: '#002855',
};

export const Primary = {
  contrastText: common.white,
  dark: '#004696',
  light: '#e8f2ff',
  main: '#0070f0',
};

export const Chip = {
  contrastText: common.white,
  dark: Secondary.main,
  light: '#FAFBFC',
  main: '#D4DBE2',
};

export const Text = {
  disabled: alpha(Secondary.main, 0.4),
  primary: Secondary.main,
  secondary: alpha(Secondary.main, 0.7),
};

export const Divider = alpha(Secondary.main, 0.12);

export const State = {
  error: {
    borderColor: 'rgba(180, 35, 24, 0.50)',
  },
  info: {
    borderColor: 'rgba(1, 108, 170, 0.50)',
  },
  pending: {
    borderColor: 'rgba(99, 67, 191, 0.50)',
  },
  primary: {
    borderColor: 'rgba(0, 112, 240, 0.50)',
  },
  secondary: {
    borderColor: alpha(Secondary.main, 0.5),
  },
  success: {
    borderColor: 'rgba(6, 118, 77, 0.50)',
  },
  warning: {
    borderColor: 'rgba(237, 108, 2, 0.50)',
  },
} as const;

export const Action = {
  activatedOpacity: 0.12,
  active: alpha(Secondary.main, 0.54),
  disabled: alpha(Secondary.main, 0.32),
  disabledBackground: Divider,
  disabledOpacity: 0.38,
  focus: alpha(Secondary.main, 0.12),
  focusOpacity: 0.12,
  hover: alpha(Secondary.main, 0.04),
  hoverOpacity: 0.04,
  selected: alpha(Secondary.main, 0.08),
  selectedOpacity: 0.08,
};
